// SPDX-License-Identifier: AGPL-3.0-or-later

import {GatewayOpcodes} from '@fluxer/constants/src/GatewayConstants';

// fluxer_gateway constants:max_payload_size/0: a larger decoded frame closes the connection.
export const GATEWAY_MAX_PAYLOAD_BYTES = 4096;

const encoder = new TextEncoder();

export function fitsLazyRequestPayload(data: object): boolean {
	return encoder.encode(JSON.stringify({op: GatewayOpcodes.LAZY_REQUEST, d: data})).length <= GATEWAY_MAX_PAYLOAD_BYTES;
}
